import { createSlice, current } from '@reduxjs/toolkit';
import { LOADING_STATUS } from '@sonifi/wb-core/common/Constants';

const initialState = {
  languages: [],
  properties: [],
  propertyFormValues: {
    group: {
      children: [],
      childrenList: [],
      city: '',
      cms_id: '',
      country: '',
      created: '',
      dst: true,
      enabled: false,
      group_type: 'property',
      id: null,
      enabled_languages: [],
      last_updated: '',
      market_type: 'hospitality',
      name: '',
      notes: '',
      phone: '',
      platform: 'Marina',
      state: '',
      uri: '',
      utc_offset: '-06:00',
    },
    users: {
      activeUsers: [],
      inactiveUsers: [],
    },
    products: {},
    staycast: {
      defaults: {},
      hyatt: {},
      marriott: {},
      preset: 'defaults',
      tokens: {},
    },
    syncUserProcessing: false,
  },
  loadingProperty: false,
  loadingProperties: LOADING_STATUS.notLoading,
  loadingSubmit: false,
};

export const adminPropertiesSlice = createSlice({
  name: 'adminProperties',
  initialState,
  reducers: {
    setProperties(state, action) {
      const { properties } = action.payload;
      state.properties = properties;
    },
    updateProperties(state, action) {
      const { property } = action.payload;
      const { properties } = current(state);
      state.properties = properties.map((p) =>
        p.id === property.id ? property : p,
      );
    },
    setPropertyFormValues(state, action) {
      const { property } = action.payload;
      const { propertyFormValues } = current(state);
      state.propertyFormValues = {
        ...propertyFormValues,
        ...property,
      };
    },
    setSyncUserProcessing(state, action) {
      state.propertyFormValues.syncUserProcessing =
        action.payload.syncUserProcessing;
    },
    setLoadingSubmit(state, action) {
      const { loadingSubmit } = action.payload;
      state.loadingSubmit = loadingSubmit;
    },
    setDefaultProperty(state) {
      state.propertyFormValues = initialState.propertyFormValues;
    },
    setLoadingProperty(state, action) {
      state.loadingProperty = action.payload;
    },
    setLoadingProperties(state, action) {
      state.loadingProperties = action.payload;
    },
    setLanguages(state, action) {
      state.languages = action.payload;
    },
    cleanPropertiesSlice() {
      return initialState;
    },
  },
});

export const {
  cleanPropertiesSlice,
  setDefaultProperty,
  setLanguages,
  setLoadingProperty,
  setLoadingProperties,
  setLoadingSubmit,
  setProperties,
  setPropertyFormValues,
  setSyncUserProcessing,
  updateProperties,
} = adminPropertiesSlice.actions;

export default adminPropertiesSlice.reducer;
